var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.064 19.5q-.645 0-1.104-.46a1.5 1.5 0 0 1-.46-1.104V6.064q0-.645.46-1.104.459-.46 1.104-.46h15.872q.644 0 1.104.46.46.459.46 1.104v11.872q0 .645-.46 1.104t-1.104.46zm16.18-12.609-7.815 5.117a2 2 0 0 1-.208.093.6.6 0 0 1-.221.037.6.6 0 0 1-.222-.037 1.4 1.4 0 0 1-.2-.093L3.755 6.891v11.045a.3.3 0 0 0 .087.221.3.3 0 0 0 .221.087h15.872a.3.3 0 0 0 .22-.087.3.3 0 0 0 .087-.221zM12 10.973l8.042-5.217H3.974zM3.756 7.091v-.905.027-.457.449-.033z"
  })));
};
export default SvgEmail;